import { FC, useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'

import { getAxiosSingle } from 'pages/api/axios'
import { CommentURL } from 'components/parts/commentaries/comments'
import numericToWord from './../../../utils/numericToWord'

interface IViewsGet {
  materialId: string | number
  materialType?: string
  wordVariants?: string[]
}

const CommentsCountGet: FC<IViewsGet> = ({ materialId, materialType, wordVariants }: IViewsGet) => {
  const [count, setCount] = useState('')

  useEffect(() => {
    const getCommentsCount = async () => {
      const query = `${CommentURL.COMMENT}/countComments?materialId=${materialId}&materialType=${materialType}`
      const result = await getAxiosSingle(query)
      setCount(String(result))
    }
    getCommentsCount()
  }, [])

  return (
    <>
      {count || <Skeleton width={50} />}&nbsp;
      {wordVariants && count && numericToWord(Number(count), wordVariants)}
    </>
  )
}

export default CommentsCountGet
